module.exports = __webpack_public_path__ + "static/media/digital.04f541cd.png";